if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return; 

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      const formData = new FormData(this.form);
      const originalId = formData.get("id");
      const Oquantity = Number(formData.get("quantity") || 1);
      const originalData = {id:originalId,quantity:Oquantity}
      const itemsToAddCart = [originalData]
      const seenLineIds = new Set([String(originalId)])
      const FREE_GIFT_ID = '16340116832601'
      const giftEnabled = document.body.getAttribute('data-free-gift') === 'true'
      if (Array.isArray(window.productIds) && window.productIds.length > 0) {
        window.productIds.forEach((productId) => {
          const pid = String(productId)
          if (seenLineIds.has(pid)) return
          if (!giftEnabled && pid === FREE_GIFT_ID) return
          seenLineIds.add(pid)
          itemsToAddCart.push({
            id: productId,
            quantity: 1
          })
        })
      }
      if (!giftEnabled) {
        for (let i = itemsToAddCart.length - 1; i >= 0; i--) {
          if (String(itemsToAddCart[i].id) === FREE_GIFT_ID) itemsToAddCart.splice(i, 1)
        }
        if (!itemsToAddCart.length) {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          return;
        }
      }
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        items:[...itemsToAddCart],
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
